import React from 'react';

import { NavWrapper, NavText, SideBarNavItem, SideBarNav } from './NavBarStyle';

const NavBar = ({ nav = [], activeSection, updateActiveSection }) => (
	<NavWrapper>
		<SideBarNav>
			{nav.map((item, index) =>(
				<SideBarNavItem
					as='li' align='center' $cursor='pointer' className='intTab__item' id={`nav${item.key}`} key={item.key} onClick={updateActiveSection(index, item.key)}>
					<NavText
						$cursor='pointer'
						color='#4a4a4a'
						active={item.key === activeSection}
						position='relative'
						left_P='11'>{item.label}
					</NavText>
				</SideBarNavItem>
			))}
		</SideBarNav>
	</NavWrapper>
);

export default NavBar;
